import 'twin.macro';
import React from 'react';
import { Menu } from '@teetsh/app/src/components/Menu';
import { Bo } from '@teetsh/app/src/types/bo';
import { ChevronDownIcon } from '@heroicons/react/24/outline';
import { useTranslation } from 'react-i18next';

interface Props {
  minimal?: boolean;
  defaultReferentielId?: string;
  onUpdateReferentiel: (id: string) => void;
  guestMode?: boolean;
  boList: Bo[];
}

export default function BoListComponent(props: Props) {
  const {
    minimal = true,
    defaultReferentielId,
    onUpdateReferentiel,
    guestMode,
    boList,
  } = props;
  const { t } = useTranslation(['referentiel']);
  const referentielName =
    boList.find(b => b.id === defaultReferentielId)?.name || boList[0]?.name;

  if (guestMode) {
    return null;
  }
  return (
    <Menu>
      <Menu.Button
        className="group"
        minimal={minimal}
        outlined
        tw="text-neutral-intense"
        small
        rightIcon={ChevronDownIcon}
      >
        {referentielName || t('referentiel:boSelector.noBo')}
      </Menu.Button>

      <Menu.Items size="auto">
        {boList.map(b => (
          <Menu.Item
            key={b.id}
            tw="whitespace-nowrap"
            onClick={() => {
              onUpdateReferentiel(b.id);
            }}
            text={b.name}
          />
        ))}
      </Menu.Items>
    </Menu>
  );
}
